// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3OebW","footer":"ModalError_footer__9Bbp2"};